const minWidth = typeof window !== "undefined" && window.innerWidth;

const styles = (theme) => ({
  textFieldL: {
    marginRight: theme.spacing.unit * 2,
    display: "block",
    minWidth: minWidth / 2,
  },
  textFieldR: {
    marginRight: theme.spacing.unit * 2,
    width: 300,
  },
  targetHeading: {
    display: "flex",
    justifyContent: "space-between",
  },
  saveTarget: {
    backgroundColor: theme.palette.accent,
    "&:hover": {
      backgroundColor: "#fd5622",
    },
  },
  button: {
    backgroundColor: theme.palette.accent,
    "&:hover": {
      backgroundColor: "#fd5622",
    },
    marginLeft: 213,
    minWidth: 85,
  },
  checkboxLabel: {
    fontWeight: 500,
    fontSize: 15,
  },
  restoreButton: {
    padding: "0 !important",
  },
  tinyInfo: {
    fontSize: 12,
    fontStyle: 'italic'
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/subtestsetting/fiberlengthloss/styles.js